export default {"src":"/_next/static/media/icon-water.6b169408.svg","height":120,"width":120,"blurWidth":0,"blurHeight":0};